module.exports = __webpack_public_path__ + "static/media/ic-category-setup-on.b82065ba.svg";